/**
 * 多选 el-select 标签折叠：最多展示 N 项，超出显示 +剩余数量
 * 用法：v-collapse-tags 或 v-collapse-tags="2"
 * 使用 class + data 属性驱动 CSS 展示，避免被 Vue 重渲染清掉
 */
function getTagNodes(tagsWrap) {
  return Array.from(tagsWrap.querySelectorAll('.el-tag')).filter(
    (node) => !node.classList.contains('collapse-tag-more')
  )
}

function applyCollapse(el, max) {
  if (el.__collapseTagsLock) return
  const tagsWrap = el.querySelector('.el-select__tags')
  if (!tagsWrap) return

  el.__collapseTagsLock = true
  try {
    // 清理旧的手动节点（如有）
    const oldMore = tagsWrap.querySelector('.collapse-tag-more')
    if (oldMore) oldMore.remove()

    const tags = getTagNodes(tagsWrap)
    tags.forEach((tag, index) => {
      tag.style.display = index < max ? '' : 'none'
    })

    const moreCount = tags.length - max
    const hasMore = moreCount > 0
    tagsWrap.classList.toggle('has-more-tags', hasMore)
    tagsWrap.classList.add('is-collapse-tags')

    if (hasMore) {
      // 优先挂在 transition-group 的 span 上，保证紧跟第 2 个 tag
      const tagGroup = tagsWrap.querySelector(':scope > span') || tagsWrap
      tagGroup.classList.add('collapse-tag-group')
      tagGroup.setAttribute('data-more-count', String(moreCount))
      tagsWrap.setAttribute('data-more-count', String(moreCount))
    } else {
      const tagGroup = tagsWrap.querySelector('.collapse-tag-group')
      if (tagGroup) {
        tagGroup.classList.remove('collapse-tag-group')
        tagGroup.removeAttribute('data-more-count')
      }
      tagsWrap.removeAttribute('data-more-count')
    }
  } finally {
    el.__collapseTagsLock = false
  }
}

function scheduleUpdate(el) {
  if (el.__collapseTagsRaf) {
    cancelAnimationFrame(el.__collapseTagsRaf)
  }
  el.__collapseTagsRaf = requestAnimationFrame(() => {
    el.__collapseTagsRaf = null
    applyCollapse(el, el.__collapseTagsMax || 2)
  })
}

function bindCollapse(el, binding) {
  const max = Number(binding.value) > 0 ? Number(binding.value) : 2
  el.__collapseTagsMax = max
  el.classList.add('collapse-tags-select')

  const update = () => scheduleUpdate(el)
  el.__collapseTagsUpdate = update

  const observer = new MutationObserver(() => {
    if (el.__collapseTagsLock) return
    update()
  })
  el.__collapseTagsObserver = observer

  const startObserve = () => {
    const tagsWrap = el.querySelector('.el-select__tags')
    if (tagsWrap && !el.__collapseTagsObserved) {
      observer.observe(tagsWrap, { childList: true, subtree: true })
      el.__collapseTagsObserved = true
    }
    update()
  }

  startObserve()
  el.__collapseTagsTimer = setTimeout(startObserve, 50)
  // 数据异步回填后再刷一次
  el.__collapseTagsTimer2 = setTimeout(update, 300)
}

function unbindCollapse(el) {
  if (el.__collapseTagsObserver) {
    el.__collapseTagsObserver.disconnect()
    el.__collapseTagsObserver = null
  }
  if (el.__collapseTagsRaf) {
    cancelAnimationFrame(el.__collapseTagsRaf)
    el.__collapseTagsRaf = null
  }
  if (el.__collapseTagsTimer) {
    clearTimeout(el.__collapseTagsTimer)
    el.__collapseTagsTimer = null
  }
  if (el.__collapseTagsTimer2) {
    clearTimeout(el.__collapseTagsTimer2)
    el.__collapseTagsTimer2 = null
  }
  el.__collapseTagsObserved = false
}

export default {
  inserted: bindCollapse,
  componentUpdated(el, binding) {
    const max = Number(binding.value) > 0 ? Number(binding.value) : 2
    el.__collapseTagsMax = max
    scheduleUpdate(el)
  },
  unbind: unbindCollapse,
}
